import { render, staticRenderFns } from "./order-form-property-cap-size.vue?vue&type=template&id=ed9b6ed0&scoped=true"
import script from "./order-form-property-cap-size.vue?vue&type=script&lang=js"
export * from "./order-form-property-cap-size.vue?vue&type=script&lang=js"
import style0 from "./order-form-property-cap-size.vue?vue&type=style&index=0&id=ed9b6ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed9b6ed0",
  null
  
)

export default component.exports